import useSWR from "swr";
import type { IWorkflowRun } from "types/workflow.types";
import { api } from "utils/axios";

interface Params {
	projectId?: number;
	applicationId?: number;
	limit?: number;
	page?: number;
}

export function useWorkflowRuns(params: Params = {}) {
	const { limit, page, ...rest } = params;
	const offset = (page ?? 0) * (limit ?? 50);
	const apiParams = { ...rest, limit, offset };
	const key = `/workflows/runs?${JSON.stringify(apiParams)}`;
	const { data, error, isValidating, mutate } = useSWR<{
		data: IWorkflowRun[];
		total: number;
	}>(key, () =>
		api.get("/workflows/runs", { params: apiParams }).then((res) => res.data),
	);
	return {
		runs: data?.data || [],
		total: data?.total || 0,
		isLoading: !error && !data,
		isError: error,
		mutate,
		isValidating,
		refetch: () => mutate(),
	};
}
